/** @format */

/** CONSTANTS **/
export * from './lib/constants/container-id.constants';
export * from './lib/constants/display-name.constants';
export * from './lib/constants/placement-id.constants';
export * from './lib/constants/price-rerank-level.constants';
export * from './lib/constants/product-recommendations-page-type.constants';

/** DAO **/
export * from './lib/dao/product.recommendations.dao';

/** INTERFACES **/
export * from '@shared/data-access/interfaces';
export {
  IRecommendationsRequestBody,
  IRecommendationsRequestUserEvent,
  IRecommendationsRequestProductDetail,
  IRecommendationsRequestProduct,
  IRecommendationsRequestPurchaseTransaction,
  IRecommendationsResponse,
  IElasticProductDetails,
  IElasticProductDetailsStyle,
  IElasticProductDetailsSKU,
  IAttribute,
  IDefiningAttribute,
  IStylePrice,
  ISKUPrice,
  ISeo,
  IRecommendationsResult,
} from './lib/interfaces/recommendations.interface';
export { SchemeStatus } from './lib/interfaces/scheme-status.interface';

/** SERVICES **/
export * from './lib/services/product.recommendations.service';
export * from './lib/services/certona.service';
export * from './lib/services/recommendation-data.service';
